export default {
  title: 'Roată',
  actions: {
    create: 'creați o roată',
    confirmDelete: 'Sunteți sigur că doriți să ștergeți această roată?',
    delete: 'Șterge',
    next: 'Următorul',
    cancel: 'Anulează',
    save: 'Salvează'
  },
  empty: {
    title: 'Fără roți',
    message: 'Pentru a crea o roată, pur și simplu faceți clic pe următorul link:'
  },
  create: {
    title: 'Creează o roată',
    fields: {
      name: 'Nume',
      date: {
        name: 'Data',
        start: 'Început',
        end: 'Sfârșit'
      },
      where: 'Unde'
    }
  },
  list: {
    name: 'nume',
    code: 'cod',
    status: 'stare',
    where: 'unde',
    date: 'dată',
    stats: 'statistică'
  }
}



// WEBPACK FOOTER //
// ./src/translations/ro/wheel.js